<template>
  <div class='press'>
    <h2>出版社数据</h2>
    <div class='content'>
      <div class='search-wrapper'>
        <i class='iconfont icon-search'/>
        <input v-model='form.keyword' type='text' class='input-search' placeholder='search'>
        <i class='iconfont icon-close' @click='clearSearchInput'/>
      </div>

      <ul>
        <li>
          <div class='cell'>
            <span class='label'>ISBN:</span>
            <input v-model='form.isbn' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>书名:</span>
            <input v-model='form.book_name' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>丛书名:</span>
            <input v-model='form.series_name' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>出版机构:</span>
            <input v-model='form.press' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>著作者:</span>
            <input v-model='form.author' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>价格:</span>
            <input v-model='form.price' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>适用分类:</span>
            <input v-model='form.apply_classification' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>适用专业:</span>
            <input v-model='form.apply_profession' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>社内分类:</span>
            <input v-model='form.clubs_classify' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>学科分类编号:</span>
            <input v-model='form.discipline_class_no' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>学科分类1:</span>
            <input v-model='form.discipline_class1' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>学科分类2:</span>
            <input v-model='form.discipline_class2' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>本季征订号:</span>
            <input v-model='form.this_solicit_num' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'>
            <span class='label'>上季征订号:</span>
            <input v-model='form.last_solicit_num' type='text' class='input' placeholder='请输入'>
          </div>
        </li>
        <li>
          <div class='cell'>
            <span class='label'>分册:</span>
            <input v-model='form.fascicle' type='text' class='input' placeholder='请输入'>
          </div>
          <div class='cell'/>
        </li>
      </ul>
      <a href='javascript:;' class='btn-search' @click='search'>查询</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    }
  },

  created() {
    this.setActiveBar('PRESS')
  },

  methods: {
    search() {
      this.$store.commit('setPressParams',this.form)
      this.goRouter('/pressresult')
    },

    clearSearchInput() {
      this.form.keyword = ''
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.press {
  width: 1200px;

  h2 {
    font-size: 20px;
    color: #000000;
    font-weight: 500;
    text-align: center;
  }

  .content {
    width: 1200px;
    height: 730px;
    background: @blue-l;
    margin: 34px auto;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding: 35px 150px;

    .search-wrapper {
      width: 440px;
      height: 30px;
      position: relative;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 10px;
      border: 1px solid #999;
      border-radius: 5px;

      .input-search {
        flex: 1;
        outline: none;
        border: none;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        padding: 0 10px;
      }

      i {
        font-size: 20px;
        color: #999;
        &.icon-close {
          color: #00c36b;
          cursor: pointer;
        }
      }
    }

    ul {
      margin-top: 57px;
      display: flex;
      flex-direction: column;
      align-items: center;

      li {
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 23px;

        .cell {
          flex: 1;
          height: 30px;
          margin: 0 40px;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          font-size: 10px;
          color: #000000;

          .label {
            display: inline-block;
            width: 100px;
            text-align: end;
            font-size: 14px;
          }

          .input {
            flex: 1;
            height: 28px;
            outline: none;
            border: none;
            margin-left: 5px;
            border-radius: 3px;
            font-size: 14px;
            text-indent: 5px;
          }
        }
      }
    }

    .btn-search {
      display: block;
      width: 250px;
      height: 40px;
      text-align: center;
      font-size: 20px;
      color: #fff;
      line-height: 40px;
      border-radius: 5px;
      background: @blue-d;
      margin: 40px auto 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Press.vue